import { render, staticRenderFns } from "./tblCalculationRcpLimits.vue?vue&type=template&id=323f27f0&scoped=true"
import script from "./tblCalculationRcpLimits.vue?vue&type=script&lang=js"
export * from "./tblCalculationRcpLimits.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "323f27f0",
  null
  
)

export default component.exports